import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import 'datatables.net';

@Component({
  selector: 'app-client-reports',
  templateUrl: './client-reports.component.html',
  styleUrls: ['./client-reports.component.scss']
})
export class ClientReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
      //this.initDatatable();
  }

  //private initDatatable(): void {
  //    $(() => {
  //        if ($.fn.dataTable.isDataTable('#table')) {
  //            let table = $('#table').DataTable();
  //        }
  //        else {

  //            $('#table').DataTable({
  //                pageLength: 25,
  //                dom: 'Bfrtip',
  //            });
  //        }
  //        $('.dataTables_length, .dataTables_filter').hide();
  //        $('.next').css('float', 'right');
  //    });
  //}

}
